(function () {
  var hasHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!hasHover || reduce) return;

  var interactiveSelector = 'a, button, [role="button"], input[type="submit"], input[type="button"], [data-cursor], [data-cursor-label]';

  function closestInteractive(target) {
    return target && target.closest ? target.closest(interactiveSelector) : null;
  }

  function initCursor() {
    var cursor = document.querySelector('.exn-cursor');
    if (!cursor || cursor.dataset.ready === 'true') return;

    cursor.dataset.ready = 'true';
    document.body.classList.add('exn-cursor-enabled');

    var label = cursor.querySelector('.exn-cursor__label');
    var mx = window.innerWidth / 2;
    var my = window.innerHeight / 2;
    var cx = mx;
    var cy = my;
    var raf = null;
    var hoverTarget = null;

    function loop() {
      cx += (mx - cx) * 0.38;
      cy += (my - cy) * 0.38;
      cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      raf = requestAnimationFrame(loop);
    }

    function startLoop() {
      if (!raf) raf = requestAnimationFrame(loop);
    }

    document.addEventListener('mousemove', function (event) {
      mx = event.clientX;
      my = event.clientY;
      if (!raf) {
        cx = mx;
        cy = my;
      }
      cursor.classList.add('is-visible');
      startLoop();
    }, { passive: true });

    document.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-visible');
    });

    document.addEventListener('mousedown', function () {
      cursor.classList.add('is-click');
    });

    document.addEventListener('mouseup', function () {
      cursor.classList.remove('is-click');
    });

    document.addEventListener('mouseover', function (event) {
      var target = closestInteractive(event.target);
      if (!target || target === hoverTarget) return;
      if (event.relatedTarget && target.contains(event.relatedTarget)) return;
      hoverTarget = target;
      cursor.classList.add('is-hover');
      if (label) label.textContent = target.dataset.cursorLabel || '';
    });

    document.addEventListener('mouseout', function (event) {
      if (!hoverTarget) return;
      if (event.relatedTarget && hoverTarget.contains(event.relatedTarget)) return;
      hoverTarget = null;
      cursor.classList.remove('is-hover');
      if (label) label.textContent = '';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCursor);
  } else {
    initCursor();
  }
})();
